/**
 * Полезные ссылки: список для пользователя, открытие через маскированный URL, админский CRUD.
 */
import { CapacitorHttp } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';
import { isPlatform } from '@ionic/vue';
import axios from 'axios';

export interface IUsefulLinkMyItem {
  id: number;
  title: string;
  sortOrder: number;
}

export interface IUsefulLinkAdmin {
  id?: number;
  title: string;
  targetUrl: string;
  visibleToAll: boolean;
  sortOrder: number;
  active: boolean;
  userIds: number[];
}

const getToken = async (): Promise<string> => {
  const { value } = await Preferences.get({ key: 'jwt' });
  return value || '';
};

const baseUrl = () => process.env.VUE_APP_API_URL || '';

async function api<T>(method: string, path: string, body?: unknown): Promise<T> {
  const token = await getToken();
  const url = `${baseUrl()}api${path}`;
  const headers: Record<string, string> = { Authorization: `Bearer ${token}` };
  if (isPlatform('ios') || isPlatform('android')) {
    const opts: any = { url, method, headers, readTimeout: 60000 };
    if (body != null) {
      headers['Content-Type'] = 'application/json';
      opts.data = JSON.stringify(body);
    }
    const res = await CapacitorHttp.request(opts);
    if (res.status >= 400) throw new Error((res.data as { message?: string })?.message || `HTTP ${res.status}`);
    return (res.data as T) ?? (undefined as T);
  }
  const config: any = { url: `api${path}`, method, headers };
  if (body != null) config.data = body;
  const { data } = await axios.request<T>(config);
  return data as T;
}

export default {
  async getMyLinks(): Promise<IUsefulLinkMyItem[]> {
    return api<IUsefulLinkMyItem[]>('GET', '/useful-links/my');
  },

  /** POST open — { url } для Browser.open / window.open */
  async openLink(id: number): Promise<{ url: string }> {
    return api<{ url: string }>('POST', `/useful-links/${id}/open`);
  },

  async adminList(): Promise<IUsefulLinkAdmin[]> {
    return api<IUsefulLinkAdmin[]>('GET', '/admin/useful-links');
  },

  async adminCreate(body: IUsefulLinkAdmin): Promise<IUsefulLinkAdmin> {
    return api<IUsefulLinkAdmin>('POST', '/admin/useful-links', body);
  },

  async adminUpdate(id: number, body: IUsefulLinkAdmin): Promise<IUsefulLinkAdmin> {
    return api<IUsefulLinkAdmin>('PUT', `/admin/useful-links/${id}`, body);
  },

  async adminDelete(id: number): Promise<void> {
    await api<unknown>('DELETE', `/admin/useful-links/${id}`);
  }
};
